import "./index.scss";

const CustomButton = ({ children, handleClick, type, selected, btnColor }) => (
  <button
    style={{ backgroundColor: btnColor }}
    onClick={handleClick}
    className={`custom-button ${type} ${selected}`}
  >
    {children}
  </button>
);

export default CustomButton;
